/* eslint-disable */
import React, { Component } from 'react'
import { View, Text, Image, TouchableOpacity } from 'react-native'
import styles from './Styles/IconPostWallV2ComponentStyle'
import Images from "../Themes/Images"

/*
<TouchableOpacity key={`btn-sound`} activeOpacity={0.8} style={{ position: 'absolute', right: 10, bottom: 10, width: 25, height: 20 }}
  onPress={onSoundToggle} >
  <Image key={`icon-sound`} style={{ width: 25, height: 20 }} source={ muted ? Images.iconSingleSoundOff : Images.iconSingleSoundOn } />
</TouchableOpacity>
*/

export default class IconPostWallComponent extends Component {
  render () {
    const { postId, viewMode, viewModeList, hasSong = false, selling, mediaType, type, muted, onSoundToggle, playing, showVideoWall, showPlayButton } = this.props
    const isMovie = mediaType == 'MP4'
    const is3d = mediaType == '3D'
    const isLink  = type > 0
    if (!selling && mediaType == 'JPEG' && type == 0)
      return null
    else if (viewModeList) {
      let viewList = []
      if (!hasSong) {
        if (isMovie && !playing && !showPlayButton)
          viewList.push(<Image key={`${postId}-icon-movie`} style={{ position: 'absolute', left: 10, bottom: 10, width: 20, height: 20 }} source={ Images.iconSinglePlay }/>)
        if (is3d)
          viewList.push(<Image key={`${postId}-icon-3d`} style={{ position: 'absolute', left: 10, bottom: 10, width: 20, height: 20 }} source={ Images.iconThumb3D }/>)
        if (isLink)
          viewList.push(<Image key={`${postId}-icon-link`} style={{ position: 'absolute', right: 10, bottom: 10, width: 20, height: 20 }} source={ Images.iconSingleLinkBlue }/>)
      }
      if (playing && !isLink && (isMovie || is3d)) {
        if (!hasSong) {
          viewList.push(
            <TouchableOpacity key={`${postId}-btn-sound`} activeOpacity={0.8} style={{ position: 'absolute', right: 10, bottom: 10, width: 26, height: 26 }}
              onPress={onSoundToggle} >
              <Image key={`${postId}-icon-sound`} style={{ width: 26, height: 26 }} source={ muted ? Images.soundBlackShadowOff : Images.soundBlackShadowOn } />
            </TouchableOpacity>
          )
        }

        if ( viewMode != 'vid' && showVideoWall) // false tapForVideoWall 30 x 33
          viewList.push(
            <TouchableOpacity key={`${postId}-btn-wall`} activeOpacity={0.8} style={{ position: 'absolute', right: 5, top: 10, width: 35, height: 34 }}
              onPress={showVideoWall}>
              <Image key={`${postId}-icon-wall`} style={{ width: 34, height: 34 }} source={ Images.enlargeIconWhite } resizeMode="contain" />
            </TouchableOpacity>
          )
      }
      return viewList
      // TODO - bottom banner for link
    }
    else
      return (
        <View style={styles.container}>
          {selling && <Image key={`${postId}-sell`} style={styles.direction} source={ Images.iconThumbKargoeTags }/>}
          {isMovie && <Image key={`${postId}-movie`} style={styles.direction} source={ Images.iconThumbPlay2 }/>}
          {is3d && <Image key={`${postId}-3d`} style={styles.direction} source={ Images.iconThumb3D }/>}
          {isLink && <Image key={`${postId}-link`} style={styles.direction} source={ Images.iconThumbLinkWhite }/>}
        </View>
      )
  }
}
